import React from 'react';
import './ModemDetails.css';
import '../../i18n';
import { useTranslation } from 'react-i18next';

import PowerOn from "../../assets/images/power-on-rotated.png"

const PowerOn_SPEC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="spec-container">
      <div className="spec-header-image">
        <img src={PowerOn} className="spec-header-image-img" />
      </div>

      <div className="spec-item full-widtli>h">
        <h2 className="spec-title">{t('accessoires.poweron.details.title')}</h2>
        <ul className="spec-details">
          <li>{t('accessoires.poweron.details.p1')}</li>
          <li>{t('accessoires.poweron.details.p2')}</li>
          <li>{t('accessoires.poweron.details.p3')}</li>
          <li>{t('accessoires.poweron.details.p4')}</li>
          <li>{t('accessoires.poweron.details.p5')}</li>
        </ul>
      </div>

    </div>
  );
};

export default PowerOn_SPEC;
